import { DateRange } from "../../../model";

/**
 * Class that allows serializing the metadata of worktime preview calculation (in relation to payroll) to Blob storage metadata and back.
 */
export class WorktimeImportPreviewMetadata {

  /** Period for the calculation */
  public period: DateRange;

  /** Salary date for the payroll, undefined for worktime. */
  public salaryDate?: string;

  /** Metadata about the preview calculations */
  public calcs: {
    /** Number of calculations, typically 1, except for "totals" */
    count: number,
    /** Total gross salary */
    gross: number,
    /** Total worker payment as net. */
    net: number,
  };

  /** Number of rows */
  public rows: {
    /** Total number of rows. */
    count: number,
    /** Rows that are in preview state: Not yet approved in source system. */
    preview: number,
    /** New rows very for approval in staging / to be committed to Palkkaus (approved in source system). */
    new: number;
    /** Rows that have been committed to Palkkaus */
    committed: number,
    /** Marked as ignored by payroll expert, will not be committed. */
    ignored: number,
    /** Deleted rows: Only committed rows can be marked deleted. If a new or preview row is deleted in source system, it is simply removed from data. */
    deleted: number,
    /** Rows manually edited, not currently in use. */
    edited: number,
    /** Rows that have validation errors and cannot be committed. */
    error: number,
  };

}

(()=>{ /* Snowpack Noop HACK for: https://github.com/snowpackjs/snowpack/issues/3585 */ })();